import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { HeadingComponent } from '@core/user-interface-legacy';

export interface FeatureDiscoveryStepperComponentI {
  heading?: string;
  content?: string;
}

@Component({
  selector: 'rt-feature-discovery-stepper',
  templateUrl: './feature-discovery-stepper.component.html',
  styleUrl: './feature-discovery-stepper.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeadingComponent],
})
export class FeatureDiscoveryStepperComponent {
  public steps = input.required<FeatureDiscoveryStepperComponentI[]>();
}
